import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    DatePicker,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,
    Alert,
    Badge,
    StatsCard,
    LucideIcon,
    Modal
} from "../../ui/ot";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "../../ui/card"
import { Upload, FileSpreadsheet, Check, X, AlertCircle, FileText, ArrowRight, TrashIcon } from "lucide-react"
import { Progress } from "../../ui/progress"
import axios from 'axios'
import { exportToExcel } from "./export_excel";

const DuplicateCheck = () => {
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false)
    const [recentUploads, setRecentUploads] = useState([])
    const [progress, setProgress] = useState(0)
    const [books, setBooks] = useState([])
    const [selectedFile, setSelectedFile] = useState(null)
    const [previewBooks, setPreviewBooks] = useState([])
    const [showPreview, setShowPreview] = useState(false)
    const [stats, setStats] = useState({
        total: 0,
        existsInSystem: 0,
        canPurchase: 0,
        duplicates: 0,
    })
    const [excelLoading, setExcelLoading] = useState(false)
    const actionRef = useRef(null);
    const bookActionRef = useRef(null);

    const columns = [
        {
            title: "#",
            dataIndex: "id",
            key: "inx",
        },
        {
            title: "書名",
            dataIndex: "title",
            key: "title",
            width: 300
        },
        {
            title: "ISBN",
            dataIndex: "ISBN",
            key: "ISBN",
        },
        {
            title: "作者",
            dataIndex: "author",
            key: "author",
        },
        {
            title: "操作",
            dataIndex: "id",
            key: "id",
            render: (text, record, index) => {
                return (
                    <Button
                        type="danger"
                        onClick={() => {
                            setPreviewBooks((pre) => {
                                return pre.filter((ele, inx) => ele?.id !== text)
                            })
                        }}>
                        <TrashIcon
                            className="h-4 w-4"
                        />刪除
                    </Button>
                )
            }
        },
    ];
    const bookcolumns = [
        {
            label: "#",
            title: "#",
            dataIndex: "id",
            key: "id",
        },
        {
            label: "書名",
            title: "書名",
            dataIndex: "title",
            key: "title",
            width: 300
        },
        {
            label: "ISBN",
            title: "ISBN",
            dataIndex: "ISBN",
            key: "ISBN",
        },
        {
            label: "作者",
            title: "作者",
            dataIndex: "author",
            key: "author",
        },
        {
            label: "重複書目",
            title: "重複書目",
            dataIndex: "exists",
            key: "exists_name",
            render: (text, record, index) => {
                return (
                    <Row justify="center">
                        <Col>
                            {!!record?.exists ? (
                                <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                                    <AlertCircle className="mr-1 h-3 w-3" /> 重複
                                </Badge>
                            ) : (
                                <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                                    <Check className="mr-1 h-3 w-3" /> 無重複
                                </Badge>
                            )}
                        </Col>

                    </Row>
                )
            }
        },
    ];
    const handleFileSelect = (e) => {
        const file = e.target.files?.[0]
        if (!file) return
        setSelectedFile(file.name)

        let form_data = new FormData();
        form_data.append("inputFile", file);
        setExcelLoading(true)
        axios
            .post(`/library/koha/bib/duplicate_check`, form_data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                let data = response?.data?.map((val, index) => {
                    return {
                        id: index + 1,
                        ...val
                    }
                })
                setPreviewBooks(data)
                setShowPreview(true)
            })
            .finally(() => {
                setExcelLoading(false)
            })
    }

    const startVerification = () => {
        setIsUploading(true)
        setProgress(0)
        setShowPreview(false)

        // Simulate progress
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 95) {
                    clearInterval(interval)
                    return 95
                }
                return prev + 5
            })
        }, 100)

        // Simulate API response
        setTimeout(() => {
            clearInterval(interval)
            setProgress(100)
            setBooks((pre) => {
                const result = previewBooks.map((value) => ({
                    ...value,
                    exists_name: value?.exists === 1 ? "重複" : "無重複"
                }));
                // 新增到 recentUploads
                setRecentUploads((prev) => [
                    {
                        id: Date.now(), // 或用 uuid
                        filename: selectedFile,
                        uploadTime: dayjs().format("YYYY-MM-DD HH:mm"),
                        status: "completed",
                        duplicates: result.filter((book) => book?.exists === 1).length,
                        books: result,
                    },
                    ...prev,
                ]);
                return result;
            });
            setStats({
                total: previewBooks.length,
                duplicates: previewBooks.filter((book) => book?.exists === 1).length,
            })
            setIsUploading(false)
        }, 2000)
    }

    const resetSelection = () => {
        setSelectedFile(null)
        setPreviewBooks([])
        setShowPreview(false)
    }

    const downloadTemplate = () => {
        const link = document.createElement('a');
        link.href = '/複本查核範例檔.xlsx'; // public 資料夾中的路徑
        link.download = '複本查核範例檔.xlsx';
        link.click();
    }

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        if (!!actionRef.current) {
            actionRef.current.reloadAndRest()
        }
    }, [previewBooks])

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mb-6">
                <StatsCard
                    layout="horizontal"
                    stats={[
                        {
                            value: 15420,
                            label: "館藏總數量",
                            color: "#3b82f6",
                            // backgroundColor: "bg-blue-50",
                            icon: <LucideIcon name="BookOpen" />,
                            iconPosition: "right",
                            animationDuration: 2000,
                            animationDelay: 0,
                        },
                        {
                            value: 234,
                            label: "已執行複本查核總數量",
                            color: "#10b981",
                            // backgroundColor: "bg-green-50",
                            icon: <LucideIcon name="AlertTriangle" />,
                            iconPosition: "right",
                            animationDuration: 1500,
                            animationDelay: 200,
                        },
                        {
                            value: "45",
                            label: "重複書目總數",
                            color: "#f97316",
                            // backgroundColor: "bg-orange-50",
                            iconPosition: "right",
                            icon: <LucideIcon name="CheckCircle" />,
                            animationDuration: 1800,
                            animationDelay: 400,
                        },
                    ]}
                    enableAnimation={false}
                    isLoading={false}
                    loadingDuration={1500}
                    size={"md"}
                    contentAlign={"left"}
                    backgroundColor={"bg-white"}
                    connection={"separated"}
                    columnsPerRow={3}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2 mt-8 
             mx-auto">
                {/* 複本查核 */}
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <Upload className="h-5 w-5" />
                            複本查核
                        </CardTitle>
                        <CardDescription>
                            上傳EXCEL檔案（書名、ISBN）檢查系統中是否有重複紀錄、館藏資料，確認圖書選購的書籍是否可以採購的
                        </CardDescription>
                        <div className="flex gap-2">
                            <Button variant="outline" className="relative bg-transparent" onClick={downloadTemplate}>
                                <LucideIcon name="Download" className="h-4 w-4 mr-2" />
                                下載範本
                            </Button>
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                            <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                            <h3 className="text-lg font-medium mb-2">上傳Excel檔案</h3>
                            <p className="text-sm text-gray-600 mb-4">支援 .xlsx 或 .xls 格式，包含書名、ISBN欄位</p>

                            <Button className="relative" loading={excelLoading}>
                                <Upload className="h-4 w-4 mr-2" />
                                選擇檔案
                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleFileSelect}
                                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                />
                            </Button>
                        </div>
                    </CardContent>
                </Card>

                {/* 上傳記錄 */}
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <LucideIcon name="Clock" className="h-5 w-5" />
                            上傳記錄
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div  className="space-y-3 flex flex-col justify-center items-center min-h-[220px]">
                            {recentUploads.length === 0 ? (
                                <div className="flex flex-col items-center justify-center text-gray-400">
                                    <FileText className="h-10 w-10 mb-2" />
                                    <div className="text-base">目前尚無上傳記錄</div>
                                    <div className="text-sm text-gray-500">請先上傳檔案進行複本查核</div>
                                </div>
                            ) : (recentUploads.map((upload) => (
                                <div key={upload?.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                    <div className="flex items-center gap-3">
                                        <FileText className="h-5 w-5 text-blue-500" />
                                        <div>
                                            <p className="font-medium">{upload?.filename}</p>
                                            <p className="text-sm text-gray-600">{upload?.uploadTime}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Badge variant={upload?.status === "completed" ? "default" : "secondary"}>
                                            {upload?.status === "completed" ? "已完成" : "處理中"}
                                        </Badge>
                                        {upload?.status === "completed" && (
                                            <span className="text-sm text-orange-600">發現 {upload?.duplicates} 筆重複</span>
                                        )}
                                        <Button type="link" onClick={() => {

                                            Modal.info({
                                                width: '1200px',
                                                title: '檢視明細',
                                                okText: "關閉",
                                                content: <>
                                                    <BookResult books={upload?.books} stats={{ total: upload?.books.length, duplicates: upload?.books.filter((book) => book?.exists === 1).length }} />
                                                </>

                                            })
                                        }}>
                                            檢視明細
                                        </Button>
                                    </div>
                                </div>
                            )))}
                        </div>
                    </CardContent>
                </Card>
            </div>

            {/* 複本查核預覽及結果 */}
            <div className="grid grid-cols-1   mx-auto">
                <Card className="mt-6">
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <LucideIcon name="AlertTriangle" className="h-5 w-5 text-orange-500" />
                            複本查核預覽及結果
                        </CardTitle>
                        <CardDescription>
                            {showPreview
                                ? `以下是從Excel檔案中讀取的書目資料，確認後請開始查核重複`
                                : !isUploading && books.length > 0
                                    ? "查核完成，以下是比對結果"
                                    : "以下是系統檢測到的重複書籍，請確認是否需要採購"}
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        {showPreview && selectedFile && (
                            <div className="mb-6 " >
                                <div className="mb-4">
                                    <div className="flex items-center gap-6  ">
                                        <div className="flex items-center gap-2 text-blue-700">
                                            <FileText className="h-4 w-4" />
                                            <span className="font-medium">檔案名稱：{selectedFile.name || selectedFile}</span>
                                        </div>
                                        <div className="text-sm text-gray-600">
                                            總筆數：<span className="text-blue-600">{previewBooks.length}</span> 筆
                                        </div>
                                        <div className="flex justify-between gap-2">
                                            <Button variant="outline" onClick={resetSelection}>
                                                重新選擇
                                            </Button>
                                            <Button onClick={startVerification}>
                                                開始查核 <ArrowRight className="ml-2 h-4 w-4" />
                                            </Button>
                                        </div>

                                    </div>
                                    <div className="flex grid grid-cols-1 items-center gap-6 mb-4">
                                        <ProTableOt
                                            searchParams={previewBooks}
                                            rowKey={"id"}
                                            actionRef={actionRef}
                                            columns={columns}
                                            check={check}
                                            setCheck={setCheck}
                                            // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                                            request={async (params = {}, sort, filter) => {
                                                let newParams = {};
                                                let order = setOrders(sort);
                                                newParams = {
                                                    ...params,
                                                    ...newParams,
                                                    order,
                                                    size: params.pageSize,
                                                    cur_page: params.current,
                                                    custom_filter_value: params.keyword ?? "",
                                                    custom_filter_key: custom_filter_key,
                                                };
                                                newParams = setParamsFilter({
                                                    ...newParams,
                                                });
                                                let startIndex = (newParams?.cur_page - 1) * newParams?.size
                                                let endIndex = Math.min(startIndex + newParams?.size, previewBooks.length)
                                                let currentData = previewBooks.slice(startIndex, endIndex)


                                                return {
                                                    data: currentData,
                                                    total: previewBooks.length
                                                }
                                            }}
                                            toolBarRender={() => {
                                                return [];
                                            }}
                                            rowSelection={false}
                                            manage_columns={true}

                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {isUploading && (
                            <div className="mb-6">
                                <div className="flex items-center gap-4 mb-2">
                                    <span className="text-sm font-medium">正在進行複本查核...</span>
                                    <span className="text-sm text-gray-600">{progress}%</span>
                                </div>
                                <Progress value={progress} className="w-full" />
                            </div>
                        )}

                        {(books.length > 0 && !isUploading) ? (
                            <div className="space-y-2">
                                <div className="flex justify-end space-x-2">
                                    <Button variant="outline"
                                        onClick={() => {
                                            setSelectedFile(null)
                                            setPreviewBooks([])
                                            setShowPreview(false)
                                            setBooks([])
                                        }}>返回</Button>
                                </div>
                                <BookResult books={books} stats={stats} />
                            </div>
                        ) : (
                            <div className="flex items-center gap-4 mb-2">
                                <span className="text-sm font-medium">請先上傳檔案進行複本查核...</span>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};
const BookResult = ({ books, stats }) => {
    const bookActionRef = useRef(null);

    const bookcolumns = [
        {
            label: "#",
            title: "#",
            dataIndex: "id",
            key: "id",
        },
        {
            label: "書名",
            title: "書名",
            dataIndex: "title",
            key: "title",
            width: 300
        },
        {
            label: "ISBN",
            title: "ISBN",
            dataIndex: "ISBN",
            key: "ISBN",
        },
        {
            label: "作者",
            title: "作者",
            dataIndex: "author",
            key: "author",
        },
        {
            label: "重複書目",
            title: "重複書目",
            dataIndex: "exists",
            key: "exists_name",
            render: (text, record, index) => {
                return (
                    <Row justify="center">
                        <Col>
                            {!!record?.exists ? (
                                <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                                    <AlertCircle className="mr-1 h-3 w-3" /> 重複
                                </Badge>
                            ) : (
                                <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                                    <Check className="mr-1 h-3 w-3" /> 無重複
                                </Badge>
                            )}
                        </Col>

                    </Row>
                )
            }
        },
    ];
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            bookcolumns,
        });
    return (<div className="space-y-2" >
        <div className="flex flex-wrap gap-4">
            <Card className="flex-1 min-w-[200px]">
                <CardHeader className="py-4">
                    <CardTitle className="text-sm font-medium">總書籍數</CardTitle>
                </CardHeader>
                <CardContent>
                    <Row justify="space-between" align="center">
                        <Col span={24}>
                            <Row justify="space-between" align="center">
                                <Col>
                                    <div className="text-2xl font-bold">{stats?.total}</div>
                                </Col>
                                <Col>
                                    <Button onClick={() => exportToExcel({
                                        data: books,
                                        headers: bookcolumns,
                                        fileName: "複本查核書目清單.xlsx"
                                    })}>
                                        下載書目清單
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </CardContent>
            </Card>
            <Card className="flex-1 min-w-[200px]">
                <CardHeader className="py-4">
                    <CardTitle className="text-sm font-medium">無重複書目</CardTitle>
                </CardHeader>
                <CardContent>
                    <Row justify="space-between" align="center">
                        <Col span={24}>
                            <Row justify="space-between" align="center">
                                <Col>
                                    <div className="text-2xl font-bold">{stats?.total - stats?.duplicates}</div>
                                </Col>
                                <Col>
                                    <Button onClick={() => exportToExcel({
                                        data: books.filter((ele) => ele?.exists === 0),
                                        headers: bookcolumns,
                                        fileName: "無重複書目.xlsx"
                                    })}>
                                        下載無重複書目清單
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardContent>
            </Card>
            <Card className="flex-1 min-w-[200px]">
                <CardHeader className="py-4">
                    <CardTitle className="text-sm font-medium">重複書目</CardTitle>
                </CardHeader>
                <CardContent>
                    <Row justify="space-between" align="center">
                        <Col span={24}>
                            <Row justify="space-between" align="center">
                                <Col>
                                    <div className="text-2xl font-bold">{stats?.duplicates}</div>
                                </Col>
                                <Col>
                                    <Button onClick={() => exportToExcel({
                                        data: books.filter((ele) => ele?.exists === 1),
                                        headers: bookcolumns,
                                        fileName: "重複書目.xlsx"
                                    })}>
                                        下載重複書目清單
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </CardContent>
            </Card>
        </div>
        <Row>
            <Col span={24}>
                <ProTableOt
                    searchParams={books}
                    rowKey={"id"}
                    actionRef={bookActionRef}
                    columns={bookcolumns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        let startIndex = (newParams?.cur_page - 1) * newParams?.size
                        let endIndex = Math.min(startIndex + newParams?.size, books.length)
                        let currentData = books.slice(startIndex, endIndex)
                        return {
                            data: currentData,
                            total: books.length
                        }
                    }}
                    toolBarRender={() => {
                        return [];
                    }}
                    rowSelection={false}
                    manage_columns={true}
                    scroll={false}
                />
            </Col>
        </Row>
    </div>)
}

export default DuplicateCheck;